import { sparql } from '@tpluscode/rdf-string';
import { update } from "./execute.mjs";
import Builder from "./index.mjs";
import DATA from "./partials/DATA.mjs";
import WHERE from "./partials/WHERE.mjs";
import INSERT from "./partials/INSERT.mjs";
import { concat } from "./TemplateResult.mjs";
export const DELETE = (strings, ...values) => ({ ...Builder(),
  ...update,
  ...WHERE({
    required: true
  }),
  ...INSERT(),
  deletePatterns: sparql(strings, ...values),

  DELETE(strings, ...values) {
    return { ...this,
      deletePatterns: concat(this.deletePatterns, strings, values)
    };
  },

  _getTemplateResult() {
    if (!this.insertPatterns) {
      return sparql`DELETE { ${this.deletePatterns} } ${this.whereClause()}`;
    }

    return sparql`DELETE { ${this.deletePatterns} } ${this.insertClause()} ${this.whereClause()}`;
  }

});

DELETE.DATA = (strings, ...values) => ({ ...Builder(),
  ...update,
  ...DATA(strings, values),

  _getTemplateResult() {
    return sparql`DELETE DATA {
  ${this.quadData}
}`;
  }

});